import { observable, action, runInAction } from 'mobx';
import { isEmpty } from 'lodash';
import Cookies from 'js-cookie';
import localforage from 'localforage';

import Service from '@service/index';

const moHeader = observable({
  popMarket: false, // 市场人才数据
  popSalary: false, // 薪酬方案工具
  popUs: false, // 关于我们
  userPop: false,
  jobname: '',
  subJobList: <any[]>[],
  isAlert: false,
  alertText: '',
});

type IKey = 'popMarket' | 'popSalary' | 'popUs' | 'userPop' | 'isAlert';
const changeValue = action((key: IKey, value: boolean) => {
  moHeader[key] = value;
  moHeader.jobname = '';
});

const changeText = action((text: string) => {
  moHeader.alertText = text;
});

const changeJobname = action((text: string) => {
  moHeader.jobname = text;
});

const getSubJob = action(async () => {
  const res = await Service.subJob();
  runInAction(() => {
    if (!isEmpty(res)) moHeader.subJobList = res;
    else moHeader.subJobList = [];
  });
});

const logoutRequest = action(async () => {
  const res: any = await Service.logout();
  console.log(res);
  // @ts-ignore
  if (res.code === 0) {
    Cookies.remove('access_token');
    localStorage.clear();
    localforage.clear();
    window.location.href = '/';
  }
});

export default moHeader;
export {
  changeValue, changeJobname, getSubJob, logoutRequest, changeText,
};
